import FormikInputLabel from "components/disw/FormikInputLabel";
import DateRangeBox from "devextreme-react/date-range-box";
import React from "react";
import { useDatePickerStyles } from "./DatePickerStyle";
import { useInputLabelStyles } from "./InputLabelStyle";

interface DatePickerProps {
  startDate?: Date;
  endDate?: Date;
  handleDateRangeChange: (value: Array<Date | undefined>) => void;
  label: string;
  required?: boolean;
  isError?: boolean;
  errorText?: string;
}

const DatePicker: React.FC<DatePickerProps> = ({
  startDate,
  endDate,
  handleDateRangeChange,
  required = false,
  label,
  errorText,
  isError = false
}) => {
  const datePickerClasses = useDatePickerStyles();
  const labelClasses = useInputLabelStyles();

  return (
    <div>
      <FormikInputLabel
        name={label}
        required={required}
        label={label}
        isError={isError}
        errorMessage={errorText}
        labelClasses={labelClasses}
      />
      <DateRangeBox
        startDate={startDate}
        endDate={endDate}
        displayFormat="dd-MMM-yyyy"
        dropDownOptions={{
          wrapperAttr: {
            class: datePickerClasses.dateBoxDropDown
          }
        }}
        useMaskBehavior={true}
        onValueChange={handleDateRangeChange}
        className={
          isError
            ? datePickerClasses.dateBoxWithError
            : datePickerClasses.dateBox
        }
        endDatePlaceholder="Select End Date"
        startDatePlaceholder="Select Start Date"
        multiView={false}
      />
    </div>
  );
};

export default DatePicker;
